// extracted by mini-css-extract-plugin
module.exports = {"container":"CatalogFilter__container","resetFilters":"CatalogFilter__resetFilters"};